import React from 'react';

import { Typography } from '@mui/material';

import { formatPrice } from './utils/formatPrice';

interface OriginalPriceProps {
  price: number;
  currency: string;
  /**
   * `inline` sits beside the current price in a sentence or a table cell; `stacked` sits under it,
   * for the debug grids that put the pair on two lines.
   */
  variant?: 'inline' | 'stacked';
}

/**
 * A price struck through, for what a figure was before a dynamic price match moved it.
 */
export default function OriginalPrice({ price, currency, variant = 'inline' }: OriginalPriceProps) {
  const isInline = variant === 'inline';
  return (
    <Typography
      component={isInline ? 'span' : 'p'}
      variant={isInline ? 'body2' : 'caption'}
      color="text.secondary"
      sx={{ ...(isInline && { ml: 0.75 }), textDecoration: 'line-through' }}
    >
      {formatPrice(price, currency)}
    </Typography>
  );
}
